var map = {
	"./faq/en/001.png": 446,
	"./faq/en/002.png": 447,
	"./faq/en/003.png": 448,
	"./faq/en/004.png": 449,
	"./faq/en/005.png": 450,
	"./faq/en/006.png": 451,
	"./faq/en/007.png": 452,
	"./faq/en/008.png": 453,
	"./faq/en/009.png": 454,
	"./faq/en/010.png": 455,
	"./faq/en/011.png": 456,
	"./faq/en/012.png": 457,
	"./faq/en/013.png": 458,
	"./faq/en/014.png": 459,
	"./faq/en/015.png": 460,
	"./faq/en/016.png": 461,
	"./faq/en/017.png": 462,
	"./faq/en/018.png": 463,
	"./faq/en/019.png": 464,
	"./faq/zh/001.png": 465,
	"./faq/zh/002.png": 466,
	"./faq/zh/003.png": 467,
	"./faq/zh/004.png": 468,
	"./faq/zh/005.png": 469,
	"./faq/zh/006.png": 470,
	"./faq/zh/007.png": 471,
	"./faq/zh/008.png": 472,
	"./faq/zh/009.png": 473,
	"./faq/zh/010.png": 474,
	"./faq/zh/011.png": 475,
	"./faq/zh/012.png": 476,
	"./faq/zh/013.png": 477,
	"./faq/zh/014.png": 478,
	"./faq/zh/015.png": 479,
	"./faq/zh/016.png": 480,
	"./faq/zh/017.png": 481,
	"./faq/zh/018.png": 482,
	"./faq/zh/019.png": 483,
	"./faq/zh/020.png": 484,
	"./faq/zh/021.png": 485,
	"./faq/zh/022.png": 486,
	"./faq/zh/023.png": 487,
	"./faq/zh/024.png": 488,
	"./faq/zh/025.png": 489,
	"./faq/zh/026.png": 490,
	"./faq/zh/027.png": 491,
	"./faq/zh/028.png": 492,
	"./faq/zh/029.png": 493,
	"./faq/zh/030.png": 494,
	"./faq/zh/031.png": 495,
	"./i18n": 86,
	"./i18n/": 86,
	"./i18n/en": 130,
	"./i18n/en.json": 130,
	"./i18n/index": 86,
	"./i18n/index.js": 86,
	"./i18n/zh-CN": 131,
	"./i18n/zh-CN.json": 131,
	"./icons/en.svg": 255,
	"./icons/form-title.svg": 496,
	"./icons/hover-1.svg": 497,
	"./icons/hover-10.svg": 498,
	"./icons/hover-11.svg": 499,
	"./icons/hover-2.svg": 500,
	"./icons/hover-3.svg": 501,
	"./icons/hover-4.svg": 502,
	"./icons/hover-5.svg": 503,
	"./icons/hover-6.svg": 504,
	"./icons/hover-7.svg": 505,
	"./icons/hover-9.svg": 506,
	"./icons/ic-announcements.svg": 507,
	"./icons/ic-arrow-left.svg": 508,
	"./icons/ic-arrow-right.svg": 509,
	"./icons/ic-arrow-top-left.svg": 510,
	"./icons/ic-arrow-top-right.svg": 511,
	"./icons/ic-bookmark-active.svg": 512,
	"./icons/ic-bookmark.svg": 513,
	"./icons/ic-download.svg": 514,
	"./icons/ic-faq.svg": 515,
	"./icons/ic-more.svg": 516,
	"./icons/ic-pin.svg": 517,
	"./icons/ic-roadmap.svg": 518,
	"./icons/ic_x.svg": 519,
	"./icons/link-symbol-copy.svg": 520,
	"./icons/link-symbol.svg": 521,
	"./icons/logo-chat.png": 256,
	"./icons/logo-deal-plus.png": 257,
	"./icons/logo-games.png": 258,
	"./icons/logo-jemjar.png": 259,
	"./icons/logo-megopoly.png": 260,
	"./icons/logo-ms.svg": 522,
	"./icons/logo-wenda.png": 261,
	"./icons/logo.svg": 523,
	"./icons/logout-copy.svg": 524,
	"./icons/logout.svg": 525,
	"./icons/luminous-BG_bottom-left.svg": 173,
	"./icons/luminous-BG_bottom-right.svg": 174,
	"./icons/luminous-BG_centr-horisontal.svg": 146,
	"./icons/luminous-BG_centr-vertical.svg": 147,
	"./icons/luminous-BG_top-left.svg": 175,
	"./icons/luminous-BG_top-right.svg": 176,
	"./icons/ms.svg": 262,
	"./icons/outer_edge_l.svg": 171,
	"./icons/outer_edge_r.svg": 172,
	"./icons/play.svg": 526,
	"./icons/play_video.svg": 527,
	"./icons/rob.png": 263,
	"./icons/title_board_c.svg": 170,
	"./icons/title_board_l.svg": 168,
	"./icons/title_board_r.svg": 169,
	"./icons/video.svg": 264,
	"./icons/zh-CN.svg": 265,
	"./images/BG_sea.jpg": 266,
	"./images/BTC-GRC.jpg": 528,
	"./images/GRC.jpg": 529,
	"./images/GRC2.0.png": 530,
	"./images/announcement.jpg": 105,
	"./images/bg-mobile.jpg": 531,
	"./images/bg_mobile.png": 267,
	"./images/city-chat.png": 268,
	"./images/city-deal-plus.png": 301,
	"./images/city-game-platform.png": 302,
	"./images/city-jemjar.png": 303,
	"./images/city-megopoly.png": 304,
	"./images/city-ms.png": 305,
	"./images/city-wenda.png": 306,
	"./images/cnVideoPreview6.jpg": 532,
	"./images/cnVideoPreview7.jpg": 533,
	"./images/cnVideoPreview8.jpg": 534,
	"./images/cnVideoPreview9.jpg": 535,
	"./images/earth.png": 307,
	"./images/earth_mobile.png": 308,
	"./images/game_roadmap_bg.png": 194,
	"./images/game_roadmap_map.png": 195,
	"./images/grc-introd-preview.jpg": 536,
	"./images/grc-viedo-preview.png": 537,
	"./images/island-cn.png": 309,
	"./images/island-en.png": 310,
	"./images/old-man-cafe-preview.png": 538,
	"./images/passport.png": 311,
	"./images/roadmap.jpg": 539,
	"./images/space.jpg": 312,
	"./images/title-mobile-china.png": 313,
	"./images/title-mobile.png": 314,
	"./images/top-title-china.png": 315,
	"./images/top-title.png": 316,
	"./rules/en/001.jpg": 540,
	"./rules/en/002.jpg": 541,
	"./rules/en/003.jpg": 542,
	"./rules/en/004.jpg": 543,
	"./rules/en/005.jpg": 544,
	"./rules/en/006.jpg": 545,
	"./rules/en/007.jpg": 546,
	"./rules/en/008.jpg": 547,
	"./rules/en/009.jpg": 548,
	"./rules/en/010.jpg": 549,
	"./rules/en/011.jpg": 550,
	"./rules/en/012.jpg": 551,
	"./rules/en/013.jpg": 552,
	"./rules/en/014.jpg": 553,
	"./rules/en/015.jpg": 554,
	"./rules/en/016.jpg": 555,
	"./rules/zh/001.jpg": 556,
	"./rules/zh/002.jpg": 557,
	"./rules/zh/003.jpg": 558,
	"./rules/zh/004.jpg": 559,
	"./rules/zh/005.jpg": 560,
	"./rules/zh/006.jpg": 561,
	"./rules/zh/007.jpg": 562,
	"./rules/zh/008.jpg": 563,
	"./rules/zh/009.jpg": 564,
	"./rules/zh/010.jpg": 565,
	"./rules/zh/011.jpg": 566,
	"./rules/zh/012.jpg": 567,
	"./rules/zh/013.jpg": 568,
	"./rules/zh/014.jpg": 569,
	"./rules/zh/015.jpg": 570,
	"./rules/zh/016.jpg": 571
};
var fakeMap = {
	"86": 9,
	"105": 7,
	"130": 3,
	"131": 3,
	"146": 7,
	"147": 7,
	"168": 7,
	"169": 7,
	"170": 7,
	"171": 7,
	"172": 7,
	"173": 7,
	"174": 7,
	"175": 7,
	"176": 7,
	"194": 7,
	"195": 7,
	"255": 7,
	"256": 7,
	"257": 7,
	"258": 7,
	"259": 7,
	"260": 7,
	"261": 7,
	"262": 7,
	"263": 7,
	"264": 7,
	"265": 7,
	"266": 7,
	"267": 7,
	"268": 7,
	"301": 7,
	"302": 7,
	"303": 7,
	"304": 7,
	"305": 7,
	"306": 7,
	"307": 7,
	"308": 7,
	"309": 7,
	"310": 7,
	"311": 7,
	"312": 7,
	"313": 7,
	"314": 7,
	"315": 7,
	"316": 7,
	"446": 7,
	"447": 7,
	"448": 7,
	"449": 7,
	"450": 7,
	"451": 7,
	"452": 7,
	"453": 7,
	"454": 7,
	"455": 7,
	"456": 7,
	"457": 7,
	"458": 7,
	"459": 7,
	"460": 7,
	"461": 7,
	"462": 7,
	"463": 7,
	"464": 7,
	"465": 7,
	"466": 7,
	"467": 7,
	"468": 7,
	"469": 7,
	"470": 7,
	"471": 7,
	"472": 7,
	"473": 7,
	"474": 7,
	"475": 7,
	"476": 7,
	"477": 7,
	"478": 7,
	"479": 7,
	"480": 7,
	"481": 7,
	"482": 7,
	"483": 7,
	"484": 7,
	"485": 7,
	"486": 7,
	"487": 7,
	"488": 7,
	"489": 7,
	"490": 7,
	"491": 7,
	"492": 7,
	"493": 7,
	"494": 7,
	"495": 7,
	"496": 7,
	"497": 7,
	"498": 7,
	"499": 7,
	"500": 7,
	"501": 7,
	"502": 7,
	"503": 7,
	"504": 7,
	"505": 7,
	"506": 7,
	"507": 7,
	"508": 7,
	"509": 7,
	"510": 7,
	"511": 7,
	"512": 7,
	"513": 7,
	"514": 7,
	"515": 7,
	"516": 7,
	"517": 7,
	"518": 7,
	"519": 7,
	"520": 7,
	"521": 7,
	"522": 7,
	"523": 7,
	"524": 7,
	"525": 7,
	"526": 7,
	"527": 7,
	"528": 7,
	"529": 7,
	"530": 7,
	"531": 7,
	"532": 7,
	"533": 7,
	"534": 7,
	"535": 7,
	"536": 7,
	"537": 7,
	"538": 7,
	"539": 7,
	"540": 7,
	"541": 7,
	"542": 7,
	"543": 7,
	"544": 7,
	"545": 7,
	"546": 7,
	"547": 7,
	"548": 7,
	"549": 7,
	"550": 7,
	"551": 7,
	"552": 7,
	"553": 7,
	"554": 7,
	"555": 7,
	"556": 7,
	"557": 7,
	"558": 7,
	"559": 7,
	"560": 7,
	"561": 7,
	"562": 7,
	"563": 7,
	"564": 7,
	"565": 7,
	"566": 7,
	"567": 7,
	"568": 7,
	"569": 7,
	"570": 7,
	"571": 7
};

function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, fakeMap[id])
	});
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var id = map[req];
		if(!(id + 1)) { // check for number or string
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return id;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 445;
module.exports = webpackAsyncContext;